import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { AvailabilityService } from '../../services/jrni/availability.service';
import { BasketService } from '../../services/jrni/basket.service';
import { DepartmentService } from '../../services/jrni/department.service';
import { ServicesService } from '../../services/jrni/services.service';
import { AlertService } from '../../_alert';
import { DatastoreService } from '../../services/datastore.service';
import { MemberService } from '../../services/jrni/member.service';
import { ApiService } from '../../services/jrni/api.service';
import {
	citizenshipClaimIds,
	citizenshipHoldPlaces,
	citizenshipRemainingFrom,
	citizenshipReservationOutcome,
} from '../../services/citizenship-capacity';

@Component({
	selector: 'app-calendar',
	templateUrl: './calendar.component.html',
	styleUrls: ['./calendar.component.scss'],
})
export class CalendarComponent implements OnInit {
	selectedDepartment;
	pageTitle;
	calendarPageText;
	minDate;
	maxDate;
	selectedDate: Date;
	currentDate: Date;
	selectedService;
	selectedLocation;
	slots: [];
	selectedSlot;
	availableDays: any;
	component: string;
	bookingsLimit: string;
	slotSelectionError = false;

	steps = [
		{ title: 'Booking questions', isActive: false },
		{ title: 'Choose appointment date and time', isActive: true },
		{ title: 'Your details', isActive: false },
		{ title: 'Summary', isActive: false },
		{ title: 'Confirmation', isActive: false },
	];

	constructor(
		private router: Router,
		private departmentService: DepartmentService,
		private servicesService: ServicesService,
		private availabilityService: AvailabilityService,
		private alertService: AlertService,
		private basketService: BasketService,
		private translateService: TranslateService,
		private spinner: NgxSpinnerService,
		public datastoreService: DatastoreService,
		private memberService: MemberService,
		private apiService: ApiService
	) { }

	routerGoBack() {
		if (this.datastoreService.skipLocationsPage) {
			this.router.navigate(['/services']);
		} else {
			this.router.navigate(['/locations']);
		}
	}

	restartJourney() {
		if (sessionStorage.getItem('journey')) {
			this.router.navigate(['start/' + sessionStorage.getItem('journey')]);
		} else {
			this.router.navigate(['/departments']);
		}
	}

	ngOnInit() {
		this.scrollToTop();
		this.component = 'calendar';
		this.spinner.show();
		// Use this.departmentService.getLocation() if the services are set on the children departments
		// Use this.departmentService.get() if the services are set on the parent department
		this.departmentService.get().then(
			(selectedDepartment) => {
				if (selectedDepartment === undefined) {
					this.restartJourney();
				} else {
					this.selectedDepartment = selectedDepartment;
					this.departmentService
						.getLocation()
						.then(async (selectedLocation) => {
							this.selectedLocation = selectedLocation;
							if (this.datastoreService.adminJourney) {
								const adminUser: any = await this.apiService.updateLocation(selectedLocation);
								console.log('admin', adminUser);
								if (adminUser._embedded && adminUser._embedded.administrators) {
									localStorage.setItem('admin_user', JSON.stringify(adminUser._embedded.administrators[0]));
								}
							}
						});

					// this.selectedLocation = this.departmentService.getLocation();

					// Set the current date to today for the calendar to default to today
					this.currentDate = new Date();
					this.selectedDate = this.currentDate;

					// Get the configurable data
					if (this.selectedDepartment.hasOwnProperty('extra')) {
						// Set the title on the login page to the title from the business question
						this.selectedDepartment.extra.hasOwnProperty('calendar_page_title')
							? (this.pageTitle =
								this.selectedDepartment.extra.calendar_page_title)
							: (this.pageTitle = 'Calendar title not set');
						// Set the extra text on the page to the text taken from the business question
						this.selectedDepartment.extra.hasOwnProperty('calendar_page_text')
							? (this.calendarPageText =
								this.selectedDepartment.extra.calendar_page_text)
							: null;
					}

					// Retrieve the selected service
					this.servicesService.get().then((service) => {
						this.selectedService = service;

						// Clear the basket
						if (this.datastoreService.adminJourney) {
							console.log('Admin journey. Use v1');
							this.basketService
								.deleteAllBaskets(this.selectedDepartment)
								.then(async (data) => {
									this.basketService.currentBasket =
										await this.basketService.createBasket(
											this.selectedDepartment
										);
									console.log(
										'Basket created',
										this.basketService.currentBasket
									);
								})
								.catch((err) => {
									this.alertService.error(
										this.translateService.instant('COMMON.GENERAL_ERR')
									);
								});
						} else {
							const basket = this.apiService
								.createBasket(this.selectedLocation)
								.subscribe((response) => {
									if (response.headers.has('auth-token')) {
										const authToken = response.headers.get('auth-token');
										localStorage.setItem('auth_token', authToken);
										console.log(`Set auth token from basket: ${authToken}`);
									}
									this.basketService.currentBasket = response.body;
									console.log(this.basketService.currentBasket);
									this.spinner.hide();
								});
						}

						this.spinner.hide();
					});
				}
			},
			(err) => {
				this.alertService.error(
					this.translateService.instant('COMMON.GENERAL_ERR')
				);
				this.spinner.hide();
			}
		);
	}

	selectSlot(slot: any) {
		this.selectedSlot = slot;
	}

	continue() {
		this.alertService.clear();
		this.availabilityService.getSelectedSlot().then(async (slot) => {
			if (slot) {
				if (this.datastoreService.isCitizenshipRoute && this.datastoreService.groupCitizenshipBooking) {
					this.spinner.show();
					const capacityOk = await this.verifyCitizenshipCapacity(slot);
					if (!capacityOk) {
						this.spinner.hide();
						this.availabilityService.setSelectedSlot(undefined);
						this.slotSelectionError = true;
						this.scrollToTop();
						return;
					}
				}
				// now we add the item
				let resource;
				try {
					// Pass the resource id, not the whole resource object. The basket calls coerce
					// whatever they are given, but an object previously reached JRNI as
					// resource_id: null, and JRNI then silently assigns whatever resource is free at
					// that slot — booking the customer into the wrong room.
					resource = await this.availabilityService.getSelectedResource();
				} catch (err) {
					console.error(err);
					this.alertService.error(
						this.translateService.instant('COMMON.GENERAL_ERR')
					);
					this.spinner.hide();
				}
				try {
					this.spinner.show();
					if (this.datastoreService.adminJourney) {
						let staffId = null;
						if (this.datastoreService.staff_set) {
							staffId = this.datastoreService.staff_set;
						}
						console.log('Admin journey. Use v1');
						const res: any = await this.basketService.addItemV1(
							this.selectedLocation,
							this.selectedService.id,
							this.selectedService.calculated_duration,
							slot.start,
							[],
							false,
							resource,
							staffId
						);
						console.log(`Item added to basket`, res);
						this.basketService.currentBasket = res;
						this.basketService.currentServiceItem = res._embedded.items[0];
					} else {
						const serviceItem = await this.apiService.addServiceItem(
							this.selectedLocation,
							this.basketService.currentBasket,
							slot.start,
							this.selectedService,
							[],
							this.selectedService.calculated_duration,
							resource
						);
						console.log(`Item added to basket`, serviceItem);
						this.basketService.currentServiceItem = serviceItem;
					}
					this.router.navigate(['/booking-details']);
				} catch (err) {
					console.error(err);
					this.alertService.error(
						this.translateService.instant('COMMON.GENERAL_ERR')
					);
					this.spinner.hide();
				}
			} else {
				this.alertService.warn(
					this.translateService.instant('CALENDAR.SLOT_WARNING')
				);
				this.slotSelectionError = true;
				this.scrollToTop();
			}
		});
	}

	private async verifyCitizenshipCapacity(slot: any): Promise<boolean> {
		try {
			const selectedSchema = this.datastoreService.selectedSchema;
			const formBuilderAnswers = JSON.parse(sessionStorage.getItem('form_builder_answers') || '{}');
			const attendeesAnswer = formBuilderAnswers?.[selectedSchema]?.['how_many_attendees_and_their_details_including_if_adult_or_child'];
			// "Myself" bookings don't display the attendees question, so a missing/blank
			// answer means a party of 1 rather than an error that blocks checkout.
			const hasAttendeesAnswer =
				attendeesAnswer !== undefined &&
				attendeesAnswer !== null &&
				`${attendeesAnswer}`.trim() !== '';
			const selectedSpaces = hasAttendeesAnswer ? parseInt(attendeesAnswer, 10) : 1;
			if (!Number.isFinite(selectedSpaces) || selectedSpaces <= 0) {
				this.alertService.error(this.translateService.instant('COMMON.CITIZENSHIP_MISSING_ATTENDEES_ANSWER'));
				return false;
			}
			const availability: any = await this.apiService.citizenshipAvailability(this.selectedLocation.id, this.selectedService.id, slot.start);
			const availableSlots = Number(availability?.slots);
			if (!Number.isFinite(availableSlots) || availableSlots <= 0 || selectedSpaces > availableSlots) {
				this.alertService.error(this.translateService.instant('COMMON.CITIZENSHIP_NOT_ENOUGH_SPACES', { spaces: Number.isFinite(availableSlots) ? availableSlots : 0 }));
				return false;
			}

			// DEL-51: the check above reserves nothing, so hold the places now. Two people
			// reaching this line within the same few minutes were both told the ceremony had
			// room; the reservation is what stops both of them proceeding on it.
			return await this.reserveCitizenshipSlot(slot, selectedSpaces);
		} catch (err) {
			console.error('verifyCitizenshipCapacity failed', err);
			this.alertService.error(this.translateService.instant('COMMON.GENERAL_ERR'));
			return false;
		}
	}

	/**
	 * Hold this ceremony's places for the party, for as long as the server allows.
	 *
	 * Only a definitive 409 stops the journey. Reservations being switched off (404), an
	 * unreachable endpoint or any other failure lets the customer carry on: bl-adelante-api
	 * re-checks the hold before a payment URL is minted, so a front end that could not
	 * reserve cannot overbook on its own — whereas wrongly claiming a ceremony is full
	 * turns someone away from a booking they could have completed.
	 */
	private async reserveCitizenshipSlot(slot: any, partyPlaces: number): Promise<boolean> {
		const lookupResponses = this.datastoreService?.lookupResponses;
		try {
			const response: any = await this.apiService.citizenshipReserve({
				company: this.selectedLocation.id,
				service: this.selectedService.id,
				slot: `${slot.start}`.slice(0, 16),
				places: citizenshipHoldPlaces(partyPlaces, lookupResponses),
				claim_ids: citizenshipClaimIds(lookupResponses),
			});
			const outcome = citizenshipReservationOutcome(response);
			if (outcome === 'full') {
				this.alertService.error(this.translateService.instant('COMMON.CITIZENSHIP_NOT_ENOUGH_SPACES', { spaces: citizenshipRemainingFrom(response) }));
				return false;
			}
			if (outcome !== 'reserved') {
				console.warn('citizenship reservation not taken', outcome);
			}
			return true;
		} catch (err: any) {
			const outcome = citizenshipReservationOutcome(err);
			if (outcome === 'full') {
				this.alertService.error(this.translateService.instant('COMMON.CITIZENSHIP_NOT_ENOUGH_SPACES', { spaces: citizenshipRemainingFrom(err) }));
				return false;
			}
			// 404 is the normal answer while reservations are off for this client.
			if (outcome !== 'unavailable') {
				console.error('citizenship reservation failed, continuing', err);
			}
			return true;
		}
	}

	// scroll to the top of the page
	scrollToTop() {
		window.scroll(0, 0);
	}
}
